import React, { useEffect, useState } from "react";
import { Button, Menu, MenuProps, Tooltip } from "antd";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import "./main-nav-styles.scss";
import { IconMonitoring } from "../icons";
import { useSelector } from "react-redux";
import {
  getAppIsMobile,
  getMainProduct,
  getProduct,
} from "../../redux/selectors";
import {
  hideMenu,
  setProduct,
  setProducts,
  setReferences,
  setReferencesFilter,
} from "../../redux/actions";
import { useAppDispatch } from "../../redux/store/hooks";
import { useNavigate } from "react-router-dom";
import { referencesService } from "../../api";

const MainNav: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useSelector(getAppIsMobile);
  //const menuIsOpen = useSelector(getAppMenuIsOpen);
  const dispatch = useAppDispatch();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const mainProduct = useSelector(getMainProduct);
  const product = useSelector(getProduct);

  useEffect(() => {
    if (mainProduct)
      referencesService
        .loadClientProducts()
        .then((resp) => {
          dispatch(setProducts(resp));
          if (window.location.pathname.includes("district")) {
            dispatch(setProduct(resp[0]?.id));
            dispatch(setReferencesFilter([resp[0]?.client?.id]));
            if (product == null || product == mainProduct?.id)
              dispatch(setReferences([resp[0]?.client?.id]));
          } else {
            dispatch(setReferencesFilter([mainProduct?.client?.id]));
            dispatch(setReferences([mainProduct?.client?.id]));
            if (product == null) dispatch(setProduct(mainProduct?.id));
          }
        })
        .catch((err) => {
          //dispatch(logoutAuth());
        });
  }, [mainProduct]);

  useEffect(() => {
    setCurrent(window.location.pathname.split("/")[1]);
    setMenuIsOpen(false);
  }, [window.location.pathname]);

  const closeMenu = (evt: any): void => {
    evt.stopPropagation();
    dispatch(hideMenu());
  };

  const handleClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
    navigate(`/${e.key}`);
  };

  const preventClick = (evt: any): void => {
    evt.stopPropagation();
  };

  const items: any = [
    {
      label: mainProduct?.client?.title,
      key: "main",
    },
    {
      label: "Районы",
      key: "districts",
    },
    {
      label: "Лента",
      key: "thread",
    },
    /*{
      label: "Аудитория",
      key: "audience",
    },*/
    {
      label: "Источники",
      key: "sources",
    },
    {
      label: "Отчеты",
      key: "reports",
    },
  ];

  mainProduct?.client?.title == "Санкт-Петербург" &&
    (items[3] = {
      label: "Лента ЖКХ",
      key: "full-thread",
    }) &&
    (items[4] = {
      label: "Источники",
      key: "sources",
    }) &&
    (items[5] = {
      label: "Отчеты",
      key: "reports",
    });

  return (
    <div
      className={menuIsOpen && isMobile ? "main-nav" : "null-length main-nav"}
      onClick={closeMenu}
    >
      <div className="main-nav__wrap" onClick={preventClick}>
        <div className="main-nav__title" onClick={() => setMenuIsOpen(true)}>
          <IconMonitoring />
          MONS
        </div>
        {menuIsOpen && isMobile && (
          <Button
            className="main-nav__btn"
            onClick={() => setMenuIsOpen(false)}
          >
            <CloseOutlined />
          </Button>
        )}

        <Menu
          onClick={handleClick}
          className={!menuIsOpen && isMobile ? "hide" : ""}
          items={items}
          selectedKeys={[current]}
          mode="inline"
        />
      </div>
    </div>
  );
};

export default MainNav;
